var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchAddition"},_vm._l((_vm.washServiceAdditionList),function(item,index){return _c('div',{key:index,staticClass:"addition-item",on:{"click":function($event){return _vm.onAddition(item)}}},[_vm._v("\n        "+_vm._s(item.additionName)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }